import React from "react";
import { useLocation } from "react-router-dom";
import ETraceDetailInfo from "../../components/Detail/_ETraceDetailInfo";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


function ETraceDetail() {
    let query = useQuery();

    return (
        <div>
            <ETraceDetailInfo ID={query.get("ID")} department={query.get("Dept")} />
        </div>
    );
}

export default ETraceDetail;